import React, { Component } from 'react';
import PropTypes from "prop-types";
import Button from "../elements/Button";
import Plan from "./Plan";
import Disclaimer2 from "../elements/Disclaimer2";

class PlanResults extends Component {

    render() {
		return (
			<div className="plans-container">
                {this.props.title ? <h3 className="m-0 mb-3 centered">{this.props.title}</h3> : ''}
				<div className="plans">
					{this.props.plans.map((data, key) => {
						return (
							<Plan
								key={key}
								title={data.title}
								speed={data.speed}
								monthlyFee={data.monthlyFee}
								activationFee={data.activationFee}
								image={data.image}
							/>
						);
					})}
				</div>
				{this.props.children}
				<div className="buttons">
					<Button
						action="tel: 1300 393 835"
						image="/images/btn-phone.svg"
						alt="Call Us"
					/>
				</div>
				<Disclaimer2 />
			</div>
		);
	}

}

PlanResults.propTypes = {
    plans: PropTypes.array,
    title: PropTypes.string
};

PlanResults.defaultProps = {
    plans: []
}

export default PlanResults;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/PlanResults.js